import React, { useState, useEffect } from 'react'
import { NavBar } from '../../components/navBar/navbar'
import { Header } from '../../components/header/header'
import LoadContainer from '../../components/loading'
import { Menu } from '../../components/menu/menu'
import './styles.css'
import { getProjectsCookies, getTasksCookies } from '../../services/updateData'
import Project from './project'
import Task from './task'
import { useContext } from 'react'
import { AuthContext } from '../../contexts/auth'

export const Tasks = () => {
	const [errorMessage, setErrorMessage] = useState(false)
	const [isLoading, setIsLoading] = useState(false)
	const [projects, setProjects] = useState([])
	const [tasks, setTasks] = useState([])
	let check = false

	const goBack = () => {
		window.location.href = '/tasks'
	}

	const goHome = () => {
		window.location.href = '/home'
	}

	const askForProjects = async () => {
		setIsLoading(true)
		const newProjects = await getProjectsCookies()
		setProjects(newProjects)
		setIsLoading(false)
	}

	const askFortasks = async (e) => {
		setIsLoading(true)
		const newTasks = await getTasksCookies(e.target.id)
		if (newTasks) {
			setTasks(newTasks)
		}
		Array.from(document.querySelectorAll('.btn-projects')).map((btn) => btn.classList.add('disabled'))
		document.querySelector('.tasks-table').classList.remove('disabled')
		document.querySelector('.goback').classList.add('disabled')
		document.querySelector('.btns-container').classList.remove('disabled')
		setIsLoading(false)
	}

	useEffect(() => {
		if (!check) {
			askForProjects()
			check = true
		}
	}, [])

	return (
		<div id="tasksPage">
			<NavBar></NavBar>
			<div className="column">
				<Menu></Menu>
				<Header></Header>
				{isLoading ? <LoadContainer></LoadContainer> : <></>}
				<div className="main-tasks">
					<div className="tasks-column">
						<span className="material-symbols-outlined goback" onClick={goHome}>
							arrow_back
						</span>
						<h1 className="tasks-title">Acompanhar Atividades</h1>
						<span className={errorMessage ? 'error' : 'error disabled'}>Sessão expirada.</span>
						<div className="btns-container disabled">
							<div className="btn-field" onClick={goBack}>
								<span className="material-symbols-outlined">arrow_back</span>
							</div>
						</div>
						<div className="projects-container">
							{projects
								? projects.map((project, index) => (
										<Project
											key={index}
											askFortasks={askFortasks}
											name={project.name}
											id={project.id}
										/>
								  ))
								: ''}
							<table className="tasks-table disabled">
								<tbody>
									<tr className="table-header">
										<th>Demanda</th>
										<th>Prazo</th>
										<th>Status</th>
									</tr>
								</tbody>
								<tbody className="tasks-table-body">
									{tasks.map((task, index) => (
										<Task key={index} task={task} />
									))}
								</tbody>
							</table>
							<div className="projects-field"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
